import { AxiosResponse } from "axios";
import { IStableDataDto, IStableDataResponse } from "../shared/types/Stabledata.type";
import axiosInstance from "./base";

export class StableData {

    static getStableData(data: IStableDataDto | null): Promise<AxiosResponse<IStableDataResponse>> {
        return axiosInstance.post('stable-review-data', data)
    }
}